import { __extends } from "tslib";
import BSSAbstractComponent from '../../bss-abstract-component/js/bss-abstract-component.js';
import checkboxSwitchTemplate from '../template/checkbox--switch.hbs';
import checkboxBusinessSwitchTemplate from '../template/checkbox--business-switch.hbs';
import { isEmpty } from 'lodash';
var checkboxTemplates = {
    checkboxSwitchTemplate: checkboxSwitchTemplate,
    checkboxBusinessSwitchTemplate: checkboxBusinessSwitchTemplate,
};
var BSSCheckboxProductTypeSwitchComponent = /** @class */ (function (_super) {
    __extends(BSSCheckboxProductTypeSwitchComponent, _super);
    /**
     *
     * @param {String} [_entityTemplate=null] _entityTemplate entity template
     * @param {String} [containerSelector=null] containerSelector component container selector
     * @param {Object} [config=null] config configuration of component
     * @param {EventManager} [EventManager=null] instance of _EventManager
     * @param {Formatter} [Formatter=null] instance of Formatter
     * @param {Resolution} [Resolution=null] Resolution class for width breakpoint handling
     * @param {object} [toolbox=null] provides common libraries: jquery and lodash
     * @param {object} [texts=null] provides texts
     * @param {object} [entityInstanceId=null] provides entityInstanceId
     */
    function BSSCheckboxProductTypeSwitchComponent(_entityTemplate, containerSelector, config, eventManager, formatter, resolution, toolbox, texts, entityInstanceId) {
        if (_entityTemplate === void 0) { _entityTemplate = null; }
        if (containerSelector === void 0) { containerSelector = null; }
        if (config === void 0) { config = null; }
        if (eventManager === void 0) { eventManager = null; }
        if (formatter === void 0) { formatter = null; }
        if (resolution === void 0) { resolution = null; }
        if (toolbox === void 0) { toolbox = null; }
        if (texts === void 0) { texts = null; }
        if (entityInstanceId === void 0) { entityInstanceId = null; }
        var _this = _super.call(this, _entityTemplate, containerSelector, config, eventManager, formatter, resolution, checkboxTemplates, toolbox) || this;
        _this._config.texts = texts;
        _this._config.entityInstanceId = entityInstanceId;
        _this._setDefaults();
        _this._setTitle();
        if (_this._independentProductId) {
            var switchedToBusiness = _this._config.resultData[_this._independentProductId].switchedToBusiness;
            if (switchedToBusiness !== null) {
                _this._eventManager.subscribe("bss-entity-created-".concat(_this._config.entityInstanceId), _this._onEntityCreated.bind(_this), _this._subscrberId);
            }
        }
        return _this;
    }
    /**
     * @desc callback on entity created, currently only for ie10 we update swiper with tabs content
     * @private
     */
    BSSCheckboxProductTypeSwitchComponent.prototype._onEntityCreated = function () {
        var switchedToBusiness = this._config.resultData[this._independentProductId].switchedToBusiness;
        if (switchedToBusiness !== null) {
            if (this._textsAdded === undefined) {
                this._textsAdded = switchedToBusiness !== 'true';
            }
            this._setState(switchedToBusiness === 'true', this._textsAdded);
        }
    };
    /**
     * @desc set switch defaults
     * @private
     */
    BSSCheckboxProductTypeSwitchComponent.prototype._setDefaults = function () {
        var _a, _b, _c, _d;
        this._$input = this._$componentEl.find('.bss-switch-checkbox_cxb') || null;
        this._$title =
            this._$componentEl.find('.bss-switch-checkbox_title') || null;
        this._$labelValue =
            this._$componentEl.find('.bss-switch-checkbox_title value') || null;
        if (this._config.isIndependent && this._config.resultData) {
            this._independentProductId = (_b = (_a = Object.values(this._config.resultData)) === null || _a === void 0 ? void 0 : _a.find(function (x) {
                return x.productType === 'it_easy_move_toyota' ||
                    x.productType === 'it_easy_move_lexus';
            })) === null || _b === void 0 ? void 0 : _b.productId;
            this._$unactiveText =
                this._$componentEl.find('.bss-switch-checkbox_texts--unactive') || null;
            this._$activeText =
                this._$componentEl.find('.bss-switch-checkbox_texts--active') || null;
            (_c = this._$unactiveText) === null || _c === void 0 ? void 0 : _c.text(this._getBoundedString(this._config.switchTexts.unactive));
            (_d = this._$activeText) === null || _d === void 0 ? void 0 : _d.text(this._getBoundedString(this._config.switchTexts.active));
        }
    };
    /**
     * @desc set title for switch label
     * set title for switch label as component is rendered outside of entity flow binding/ ui-description
     * @private
     */
    BSSCheckboxProductTypeSwitchComponent.prototype._setTitle = function () {
        var _a, _b;
        var configTitle = this._config.title || null;
        if (isEmpty(this._config.texts)) {
            this._config.texts = this._toolbox.layoutTexts || {};
        }
        // no need to refresh a whole template, we set only title value
        if ((configTitle === null || configTitle === void 0 ? void 0 : configTitle.indexOf('data-text')) !== -1 &&
            Object.keys(this._config.texts).length) {
            (_a = this._$labelValue) === null || _a === void 0 ? void 0 : _a.text(this._getBoundedString(configTitle));
        }
        if (this._config.isIndependent &&
            ((_b = this._config.resultData[this._independentProductId]) === null || _b === void 0 ? void 0 : _b.switchedToBusiness) === 'true') {
            this._$title.removeClass('hidden');
        }
    };
    /**
     * @desc set checkbox state
     * @param {boolean} checked checkbox state
     * @private
     */
    BSSCheckboxProductTypeSwitchComponent.prototype._setState = function (checked, textsAdded) {
        var _this = this;
        var _a;
        if (checked === void 0) { checked = false; }
        if (textsAdded === void 0) { textsAdded = null; }
        if ((_a = this._$input) === null || _a === void 0 ? void 0 : _a.length) {
            this._$input.removeClass('is-checked');
            if (this._independentProductId)
                this._$title.addClass('hidden');
            if (checked) {
                this._$input.addClass('is-checked');
                if (this._independentProductId)
                    this._$title.removeClass('hidden');
            }
        }
        if (checked &&
            textsAdded != null &&
            textsAdded === false &&
            this._config.isIndependent) {
            this._textsAdded = checked;
            this._config.additionalGrossTexts.forEach(function (textConfig) {
                var selector = textConfig.global
                    ? "[data-text='".concat(textConfig.selector, "']")
                    : "[data-product='".concat(_this._independentProductId, "'] [data-text='").concat(textConfig.selector, "']");
                var $elements = _this._toolbox.$(selector);
                $elements.each(function (_, el) {
                    var $el = _this._toolbox.$(el);
                    var shouldExclude = (textConfig.excludeFromParent || []).some(function (className) { return $el.closest(".".concat(className)).length > 0; });
                    if (!shouldExclude) {
                        $el.after("<span data-id=\"additionalGrossText\">&nbsp;".concat(_this._getBoundedString(_this._config.additionalGrossText), "</span>"));
                    }
                });
            });
        }
        else if (!checked &&
            textsAdded != null &&
            textsAdded === true &&
            this._config.isIndependent) {
            this._removeGlobalIndicators();
        }
    };
    BSSCheckboxProductTypeSwitchComponent.prototype._removeGlobalIndicators = function () {
        var _this = this;
        var selector = "[data-id='additionalGrossText']";
        var $elements = this._toolbox.$(selector);
        $elements.each(function (_, el) {
            _this._toolbox.$(el).remove();
        });
        this._textsAdded = false;
    };
    return BSSCheckboxProductTypeSwitchComponent;
}(BSSAbstractComponent));
export default BSSCheckboxProductTypeSwitchComponent;
